module.exports = __webpack_public_path__ + "img/sumbittrue.9d892154.png";